export enum SearchResultType {
    Course = 'course',
    Certificate = 'certificate',
    Document = 'document',
}
